import CustomTooltip from "@/components/desktop/tooltip/CustomTooltip";

const TableMultiple = ({ textItems, reduceText, showFunction, showTitle }) => {
	const items = textItems && textItems.split(",");

	return (
		<>
			{items &&
				items.map((item, j) => {
					if (j > 1) {
						return null;
					}

					return (
						<div
							key={j}
							style={{
								marginLeft: "5px",
								textAlign: "center",
							}}
						>
							{reduceText ? <CustomTooltip text={reduceText(item)} description={item} /> : item}
						</div>
					);
				})}
			{items && items.length > 2 && (
				<span
					style={{
						fontWeight: "bold",
						color: "#7fb02f",
						cursor: "pointer",
						fontStyle: "italic",
					}}
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();

						showFunction(showTitle, items);
					}}
				>
					{`Ver ${items.length - 2} más`}
				</span>
			)}
		</>
	);
};

export default TableMultiple;
